<template>
  <section class="is-full-height is-full-width">
    <component
      :is="component"
      :value="form"
      :jurisdiction-id="jurisdictionId"
      :show-billing-plan="showBillingPlan"
      :has-early-exit="hasEarlyExit"
      :hide-back-button="hideBackButton"
      :has-title-primary="hasTitlePrimary"
      :sbow-couple-toggle="showCoupleToggle"
      :has-call-to-action="hasCallToAction"
      :is-external="isExternal"
      @flow-change="onFlowChange"
      @on-goals-input="onGoalsInput"
      @on-situations-input="onSituationsInput"
      v-on="$listeners"
    />
  </section>
</template>

<script>
import { LightDiagnosticForm } from '@/modules/lightdiagnostic/models/LightDiagnosticForm';
import LightDiagnosticSituation from '@/modules/lightdiagnostic/components/presentational/LightDiagnosticSituation.vue';
import { LightDiagnosticMixin } from '@/modules/lightdiagnostic/mixins/LightDiagnosticMixin';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'LightDiagnostic',
  emits: ['on-goals-input', 'on-situations-input', 'on-plan-selected', 'on-plan-calculated'],
  mixins: [LightDiagnosticMixin],
  data() {
    return {
      form: new LightDiagnosticForm({
        coupleType: this.estatePlanPartyType?.key,
        partnershipInvitationType: this.partnershipInvitationType
      }),
      component: LightDiagnosticSituation
    };
  },
  methods: {
    onFlowChange(component) {
      this.component = component;
    },
    onGoalsInput(goals) {
      this.form.goals = goals ?? [];
      this.$emit('on-goals-input', this.form.goals);
    },
    onSituationsInput(situations) {
      this.form.situations = situations ?? [];
      this.$emit('on-situations-input', this.form.situations);
    }
  }
};
</script>

<style scoped></style>
